import { Component, Input, ChangeDetectionStrategy } from '@angular/core';


/**
 * Small, reusable "action needed" badge (amber pill with a bell). Used wherever an item
 * (plant card, bed row, loose-culture tile) is waiting for a user action, so the visual is
 * identical everywhere (home + Mon Potager). Icon-only by default; pass [label] where space allows.
 */
@Component({
  selector: 'vw-action-badge',
  standalone: true,
  imports: [],
  templateUrl: './action-badge.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './action-badge.component.scss',
})
export class ActionBadgeComponent {
  @Input() label?: string;
  @Input() ariaLabel = '';
}
